import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    error: "#E53E3E",
    grey: {
      50: "#F7FAFC",
      100: "#EDF2F7",
      200: "#E2E8F0",
      300: "#CBD5E0",
      400: "#A0AEC0",
      500: "#718096",
      600: "#4A5568",
      700: "#2D3748",
      800: "#1A202C",
      900: "#171923",
    },
    olive: {
      100: "#5A725C",
      200: "#516753",
      300: "#485B4A",
      400: "#3F5041",
      500: "#364538",
      600: "#2D392F",
      700: "#212922",
      800: "#1B221C",
      900: "#121713",
    },
    green: {
      25: "#EEF1EE",
      50: "#D4DDD5",
      100: "#51906A",
      200: "#4B8562",
      300: "#447959",
      400: "#3E6E51",
      500: "#386249",
      600: "#315740",
      700: "#2B4B38",
      800: "#24402F",
      900: "#1E3427",
    },
    feldgrau: {
      100: "#68A192",
      200: "#619688",
      300: "#5A8C7F",
      400: "#538175",
      500: "#4C766B",
      600: "#446B61",
      700: "#3D6158",
      800: "#36564E",
      900: "#2F4B44",
    },
    bole: {
      100: "#B3716B",
      200: "#A96964",
      300: "#9E615C",
      400: "#945955",
      500: "#89524E",
      600: "#7F4A46",
      700: "#74423F",
      800: "#6A3A37",
      900: "#5F3230",
    },
    lion: {
      100: "#E3CEB5",
      200: "#DEC5A8",
      300: "#DABD9B",
      400: "#D5B48E",
      500: "#D0AB81",
      600: "#CBA273",
      700: "#C79A66",
      800: "#C29159",
      900: "#BD884C",
    },
    graphPrimary: {
      50: "#f0f9f4",
      100: "#d4eadb",
      200: "#b8ddc2",
      300: "#9bd0a9",
      400: "#7fc391",
      500: "#5D8A7A",
      600: "#4c7265",
      700: "#3b5a50",
      800: "#2a423b",
      900: "#192a26",
    },
    graphSecondary: {
      50: "#f9f5f2",
      100: "#f0e8e2",
      200: "#e7d9d1",
      300: "#decac1",
      400: "#d5bbb1",
      500: "#A8836E",
      600: "#8d6d5a",
      700: "#735848",
      800: "#584336",
      900: "#3e2e24",
    },
  },
  components: {
    Button: {
      variants: {
        primary: {
          bg: "green.400",
          color: "white",
          _hover: {
            bg: "green.600",
            boxShadow: `0px 1px 2px #315740`,
          },
          _active: {
            bg: "green.800",
          },
          _disabled: {
            bg: "green.400",
            color: "white",
            opacity: 0.4,
            cursor: "not-allowed",
            pointerEvents: "none",
            boxShadow: "none",
          },
        },
        secondary: {
          bg: "white",
          color: "#3D6158",
          border: "1px solid #3D6158",
          _hover: {
            color: "#36564E",
            boxShadow: `0px 0.5px 1px #36564E`,
          },
          _active: {
            color: "#2F4B44",
            boxShadow: `0px 1px 2px #2F4B44`,
          },
          _disabled: {
            bg: "white",
            color: "#3D6158",
            opacity: 0.4,
            cursor: "not-allowed",
            pointerEvents: "none",
            boxShadow: "none",
          },
        },
        warn: {
          bg: "error",
          color: "white",
          _hover: {
            bg: "red.600",
          },
          _active: {
            bg: "red.700",
          },
        },
        closeX: {
          color: "black",
          border: "none",
          _hover: {
            bg: "grey.50",
            boxShadow: `0px 1px 2px #E2E8F0 !important`,
          },
          _active: {
            bg: "grey.100",
            boxShadow: `0px 2px 4px #CBD5E0 !important`,
          },
        },
      },
    },
    IconButton: {
      variants: {
        primary: (props: any) => ({
          ...theme.components.Button.variants.primary(props),
        }),
        secondary: (props: any) => ({
          ...theme.components.Button.variants.secondary(props),
        }),
      },
    },
    Editable: {
      padding: "0rem",
      baseStyle: {
        input: {
          _focus: {
            boxShadow: "none",
          },
        },
      },
    },
    Checkbox: {
      baseStyle: {
        control: {
          "&[data-focus-visible]": {
            boxShadow: "none",
            "--chakra-ring-shadow": "none",
            "--chakra-ring-color": "transparent",
          },
        },
      },
    },
  },
});

export default theme;
